import styled from "styled-components";

/**
 * Wrapper das ações
 * Layout flexível para posicionar botões à direita.
 */
export const ActionsWrapper = styled.div`
  display: flex;
  width: ${({ theme }) => theme.spacing(12)};
  height: fit-content;
  right: ${({ theme }) => theme.spacing(1)};
  gap: ${({ theme }) => theme.spacing(1)};
  top: ${({ theme }) => theme.spacing(10)};
  justify-content: flex-end;
  z-index: 999;
`;
/**
 * Botão de ação
 * Botão de ação com ícone e texto.
 */
const ActionButton = styled.button`
  font-weight: ${({ theme }) => theme.fontWeights.extraLight};
  border-radius: ${({ theme }) => theme.spacing(1.5)};
  font-size: ${({ theme }) => theme.fontSizes.xs};
  color: ${({ theme }) => theme.colors.black};
  padding: ${({ theme }) => theme.spacing(0.5)}
    ${({ theme }) => theme.spacing(0.85)};
  transition: all 0.2s ease-in-out;
  cursor: pointer;
  border: none;

  &:hover {
    opacity: 0.9;
  }

  &:disabled {
    background-color: ${({ theme }) => theme.colors.lightGray};
    cursor: not-allowed;
  }

  & > svg {
    color: ${({ theme }) => theme.colors.black} !important;
    fill: ${({ theme }) => theme.colors.black};
    width: ${({ theme }) => theme.spacing(3.5)};
    stroke-width: 0;
  }
`;

/**
 * Botão de cancelar (limpar)
 */
export const CancelButton = styled(ActionButton)`
  background-color: ${({ theme }) => theme.colors.lightRed};
`;

/**
 * Botão de aplicar (confirmar)
 */
export const ApplyButton = styled(ActionButton)`
  background-color: ${({ theme }) => theme.colors.lightGreen};
`;
